<div class="form-holder">
  <vc-poll-card-header *ngIf="!invitations" [image]="'assets/planifier.svg'" [title]="'POLL-CREATION.FORM.COMMUNICATIONS' | translate" [description]="'POLL-CREATION.FORM.COMMUNICATIONS-DESC' | translate">
  </vc-poll-card-header>
  <vc-poll-card-header *ngIf="invitations" [image]="'assets/planifier.svg'" title="Connexion" description="{{'POLL-CREATION.FORM.COMM-DESC' | translate}}">
  </vc-poll-card-header>
  <div class="safe-area">
    <p *ngIf="!invitations">
      <input id="convocation-check" type="checkbox" (change)="setupConvocations()">
      <span class="subtitle">{{'TIMER.CONVOCATIONS' | translate}}</span>
    </p>
    <input *ngIf="displayConvocations && !invitations" type="date" id="convocation-date" (change)="onConvocationDate($event)" placeholder="{{'POLL-CREATION.FORM.START-DATE-PLACEHOLDER' | translate}}"
             [ngClass]="isValidInviteDate == true ? 'date-valid' : 'date-invalid'" [value]="convocationDate">
    <input *ngIf="displayConvocations && !invitations" type="time" id="convocation-time" (focusout)="onConvocationTime($event)"
             [ngClass]="isValidInviteTime == true ? 'date-valid' : 'date-invalid'" [value]="convocationTime">
    <p *ngIf="invitations">
      <input id="invitations-check" type="checkbox" (change)="setupInvitations()">
      <span class="subtitle">Programmer l'envoi des invitations</span>
    </p>
    <input *ngIf="invitations && displayInvitations" type="date" id="invite-date" (change)="onInviteDate($event)" [value]="initialInviteDate"
             [ngClass]="isValidInviteDate == true ? 'date-valid' : 'date-invalid'">
    <input *ngIf="invitations && displayInvitations" type="time" id="invite-time" (focusout)="onInviteTime($event)" [value]="initialInviteTime"
             [ngClass]="isValidInviteTime == true ? 'date-valid' : 'date-invalid'">
  </div>
</div>
